import {displayError} from "./feature-toast";
import urls from "./urls";

// The account billing summary and saved cards for the billing and card modals of the common bundle. They lived in
// src/ads/js/api.js, and that import pulled the whole ads code into the common bundle of every page.
export async function getBillingData() {
    return $.ajax({
        url: urls.getUserBilling,
        method: 'get',
        success: function (response) {
            return response
        },
        error: function (response) {
            displayError('Error in getting billing data')
            console.log(response)
        }
    });
}

export async function getUserCards() {
    return $.ajax({
        url: urls.getUserCards,
        method: 'get',
        success: function (response) {
            return response
        },
        error: function (response) {
            displayError('Error in getting user cards')
            console.log(response)
        }
    });
}
